import axios from 'axios';

export const PRODUCT_PUBLISHED = 'PRODUCT_PUBLISHED';
export const PRODUCT_PUBLISHED_ERROR = 'PRODUCT_PUBLISHED_ERROR';

const publishProduct = (teamId, productId, data) => (
  dispatch => (
    axios.put(`/api/teams/${teamId}/products/${productId}`, data).then((response) => {
      dispatch({
        type: PRODUCT_PUBLISHED,
        product: response.data.data,
      });

      return true;
    }).catch((error) => {
      if (error.response && error.response.status === 401) {
        window.location = '/login';
      }

      if (error.response && error.response.data) {
        dispatch({
          type: PRODUCT_PUBLISHED_ERROR,
          message: error.response.data.message,
          errors: error.response.data.errors ? error.response.data.errors : {},
        });
      } else {
        dispatch({
          type: PRODUCT_PUBLISHED_ERROR,
          message: 'An error occurred while publishing the product',
          errors: {},
        });
      }

      console.log(error);

      return false;
    })
  )
);

export default publishProduct;
